<template>
  <div class="add-basic-information">
    <div class="add-title">
      <span class="basic title-font-style">交易账户-银行转账</span>
      <div class="save">
        <el-button v-if="isEdit" type="primary" @click="onAccount" plain>添加账户</el-button>
        <el-button
          type="primary"
          v-if="(this.$route.path === '/crm/customer/details'||this.$route.path === '/crm/supplier/supplierEdit')&&isEdit"
          @click="onSave"
        >保存</el-button>
        <el-button
          type="primary"
          v-if="(this.$route.path === '/crm/customer/details'||this.$route.path === '/crm/supplier/supplierEdit')&&!isEdit"
          @click="onDetail"
        >编辑</el-button>
      </div>
    </div>
    <div
      v-for="(item,index) in queryParams"
      :key="index"
      class="add-content"
      style="padding-left:50px;padding-bottom:10px"
    >
      <el-form
        class="demo-form-inline"
        :label-width="!isEdit ? '' : '95px'"
        :rules="supplierRules"
        ref="queryParams"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="账户名称：">
              <span>{{cusName||'--'}}</span>
              <el-button
                v-if="item.isDefault === true"
                size="mini"
                class="main-contact"
                style="position: absolute;right:12px"
              >主账号</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银行账号：">
              <el-input v-if="isEdit" v-model="item.bankAccount"></el-input>
              <span v-else>{{item.bankAccount || '--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户行：">
              <el-input v-if="isEdit" v-model="item.bankOpencount"></el-input>
              <span v-else>{{item.bankOpencount || '--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="银行行号：">
              <el-input v-if="isEdit" v-model="item.bankCode"></el-input>
              <span v-else>{{item.bankCode || '--'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="!item.isDefault">
          <el-col :span="24" style="text-align:right;margin-top:10px;margin-bottom:10px;">
            <el-button v-if="!item.isDefault" @click="onDelete(item,index)">删除</el-button>
            <el-button
              @click="onMainLinkman(item,index)"
              v-if="!item.isDefault"
              plain
              type="primary"
            >设为主账号</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  supplierBankUpdateById,
  supplierBankUpdateByIsDefault,
  supplierBankDelete
} from '@/api/supplier/supplierManage'
import {
  customerBankUpdate,
  customerBankUpdateByIsDefault,
  customerBankDelete
} from '@/api/customer/customerManage'
export default {
  props: ['isShow', 'customerBankList', 'cusName', 'ciName'],
  data () {
    return {
      queryParams: [
        {
          isDefault: true,
          suId: '',
          id: '',
          flag: true
        }
      ],
      supplierRules: {
        productClass: [{ required: true }],
        proType: [{ required: true }]
      }, // 校验规则
      isEdit: false
    }
  },
  watch: {
    customerBankList: {
      handler (val) {
        this.queryParams = JSON.parse(JSON.stringify(val))
      },
      deep: true
    }
  },
  mounted () {
    this.isEdit = this.isShow
  },
  methods: {
    // 添加账户
    onAccount () {
      if (
        this.$route.path === '/crm/customer/details' ||
        this.$route.path === '/crm/customer/addCustomers'
      ) {
        if (this.$route.path === '/crm/customer/details') {
          const params = {
            isDefault: false,
            cusId: this.$route.query.id,
            flag: true
          }
          this.queryParams.push(params)
        } else {
          const params = {
            isDefault: false,
            flag: true
          }
          this.queryParams.push(params)
        }
      } else {
        const params = {
          isDefault: false,
          suId: this.$route.query.id,
          flag: true
        }
        this.queryParams.push(params)
      }
    },
    // 删除
    onDelete (val, index) {
      if (this.queryParams.length > 1) {
        if (
          this.$route.path === '/crm/customer/addCustomers' ||
          this.$route.path === '/crm/supplier/supplierAdd'
        ) {
          if (val.isDefault === true) {
            this.queryParams.splice(index, 1)
            this.queryParams[0].isDefault = true
          } else {
            this.queryParams.splice(index, 1)
          }
        } else {
          // 客户管理,供应商管理详情交易账户删除
          if (val.id) {
            if (this.$route.path === '/crm/customer/details') {
              // 客户详情删除收货人
              this.getCustormerBank(val.id, index)
            } else if (this.$route.path === '/crm/supplier/supplierEdit') {
              // 供应商详情删除收货人
              this.getSupplierBank(val.id, index)
            }
          } else {
            // 没有保存的数据删除
            this.queryParams.splice(index, 1)
          }
        }
      } else {
        this.$message.error('交易账户必须保留一个!')
      }
    },
    // 删除客户账户
    getCustormerBank (id, index) {
      customerBankDelete(id)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams.splice(index, 1)
            this.queryParams.forEach((item) => {
              // 根据返回的id设置主账号
              if (item.id === res.data.obj) {
                item.isDefault = true
              }
            })
            this.$message.success('删除成功!')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 删除供应商账户
    getSupplierBank (id, index) {
      supplierBankDelete(id)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams.splice(index, 1)
            this.queryParams.forEach((item) => {
              // 根据返回的id设置主账号
              if (item.id === res.data.obj) {
                item.isDefault = true
              }
            })
            this.$message.success('删除成功!')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 保存
    onSave () {
      this.isEdit = false
      if (this.$route.path === '/crm/supplier/supplierEdit') {
        supplierBankUpdateById(this.$route.query.id, this.queryParams)
          .then((res) => {
            // 供应商交易账户保存
            if (res.data.code === 200) {
              this.queryParams = res.data.obj
              this.$message.success('保存成功!')
              this.isEdit = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else if (this.$route.path === '/crm/customer/details') {
        const list = JSON.parse(JSON.stringify(this.queryParams))
        list.forEach(ele => {
          if (ele.id === null) {
            delete ele.id
          }
          if (ele.cusId === null) {
            ele.cusId = this.$route.query.id
          }
        })
        // 客户交易账户保存
        customerBankUpdate(list)
          .then((res) => {
            if (res.data.code === 200) {
              this.queryParams.forEach(element => {
                element.ciName = this.ciName
              })
              this.$message.success('保存成功!')
              this.isEdit = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    // 编辑
    onDetail () {
      this.isEdit = true
    },
    // 设为主账号
    onMainLinkman (row, index) {
      if (row.id) {
        if (this.$route.path === '/crm/customer/details') {
          // 客户详情设为主账户
          customerBankUpdateByIsDefault(row.id, row.cusId)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success('已成功设为主账号')
                for (let i = 0; i < this.queryParams.length; i++) {
                  if (i === index) {
                    this.queryParams[i].isDefault = true
                  } else {
                    this.queryParams[i].isDefault = false
                  }
                }
                this.queryParams.unshift(this.queryParams[index])
                this.queryParams.splice(index + 1, 1)
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.$route.path === '/crm/supplier/supplierEdit') {
          // 供应商详情设为主账号
          supplierBankUpdateByIsDefault(row.id, row.suId)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success('已成功设为主账号')
                for (let i = 0; i < this.queryParams.length; i++) {
                  if (i === index) {
                    this.queryParams[i].isDefault = true
                  } else {
                    this.queryParams[i].isDefault = false
                  }
                }
                this.queryParams.unshift(this.queryParams[index])
                this.queryParams.splice(index + 1, 1)
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      } else {
        const list = JSON.parse(JSON.stringify(this.queryParams))
        this.queryParams = []
        list.forEach((ele, i) => {
          if (i === index) {
            ele.isDefault = true
            this.queryParams.unshift(ele)
          }
          if (i !== index) {
            ele.isDefault = false
            this.queryParams.push(ele)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
